/**
 * ÉCLAT FINE JEWELRY - QUICK ADD MODAL & SELECTION
 */

class QuickAddModal {
  constructor() {
    this.overlay = document.querySelector('.quick-add-modal-overlay');
    this.modalContent = document.querySelector('.quick-add-modal__dynamic-body');
    this.closeBtn = document.querySelector('.quick-add-modal__close');
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-quick-add-handle]');
      if (trigger) {
        e.preventDefault();
        const handle = trigger.dataset.quickAddHandle;
        this.openWithProduct(handle);
      }
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });
    }
  }

  async openWithProduct(handle) {
    if (!this.overlay || !this.modalContent) return;

    this.modalContent.innerHTML = `
      <div style="padding: 3rem; text-align: center;">
        <p style="font-family: var(--font-serif); font-size: 1.25rem;">Consulting Atelier Registry...</p>
      </div>
    `;
    this.overlay.classList.add('is-open');

    try {
      const res = await fetch(`/products/${handle}?view=quick-add-json`);
      if (res.ok) {
        const productHtml = await res.text();
        this.modalContent.innerHTML = productHtml;
      } else {
        // Fallback standard product fetch
        const resFallback = await fetch(`/products/${handle}.js`);
        const product = await resFallback.json();
        this.renderFallback(product);
      }
    } catch (err) {
      console.error('Error opening quick add:', err);
    }
  }

  renderFallback(product) {
    const primaryImg = product.images && product.images[0] ? product.images[0] : '';
    const formattedPrice = (product.price / 100).toFixed(2);
    const variantsOptions = product.variants.map(v => `
      <option value="${v.id}">${v.title} — $${(v.price / 100).toFixed(2)}</option>
    `).join('');

    this.modalContent.innerHTML = `
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem; padding: 2.5rem;">
        <div>
          <img src="${primaryImg}" alt="${product.title}" style="width: 100%; aspect-ratio: 1/1; object-fit: cover;">
        </div>
        <div>
          <p style="font-size: 0.75rem; letter-spacing: 0.2em; text-transform: uppercase; color: var(--color-accent-gold); margin-bottom: 0.5rem;">Atelier Exclusive</p>
          <h3 style="font-family: var(--font-serif); font-size: 1.75rem; margin-bottom: 0.5rem;">${product.title}</h3>
          <p style="font-size: 1.125rem; font-weight: 500; margin-bottom: 1.5rem;">$${formattedPrice} ${window.EclatShop.currency.active}</p>
          
          <form action="/cart/add" method="post" style="margin-bottom: 1.5rem;">
            <div style="margin-bottom: 1.25rem;">
              <label style="display: block; font-size: 0.75rem; text-transform: uppercase; margin-bottom: 0.5rem; letter-spacing: 0.1em;">Select Metal / Size</label>
              <select name="id" style="width: 100%; padding: 10px; border: 1px solid var(--color-border); background: #fff; font-family: inherit;">
                ${variantsOptions}
              </select>
            </div>
            <button type="submit" class="btn-luxury" style="width: 100%;">Add to Atelier Bag</button>
          </form>
          
          <a href="${product.url}" onclick="if (window.openPdpProduct) { event.preventDefault(); if (window.EclatQuickAddInstance) window.EclatQuickAddInstance.close(); window.openPdpProduct('${(product.title || '').replace(/'/g, "\\'")}'); }" style="font-size: 0.8125rem; text-decoration: underline; color: var(--color-text-secondary);">View Full Atelier Details & Hallmarks →</a>
        </div>
      </div>
    `;
  }

  close() {
    if (this.overlay) {
      this.overlay.classList.remove('is-open');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new QuickAddModal();
});
